import { render, staticRenderFns } from "./UnknownPassengerInfo.vue?vue&type=template&id=9167f58c&scoped=true"
import script from "./UnknownPassengerInfo.vue?vue&type=script&lang=js"
export * from "./UnknownPassengerInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9167f58c",
  null
  
)

export default component.exports